function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "14",
  viewBox: "0 0 17 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.39 9.153l-.11-1.828H.498l-.11 1.828h3z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.604 5.576h2.57l-.11-1.828H.713l-.11 1.828z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.283 10.9L0 14h3.778l-.283-3.1H.283z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.958 1.999L2.838 0H.94L.82 1.999h2.138z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.813 2.784v2.612L8.92 2.784v2.662L4.97 2.784V14h12.028V5.647l-4.185-2.863zM8.654 12.01H6.86v-1.854h1.796v1.854h-.002zm0-3.2H6.86V6.959h1.796v1.853h-.002zm3.228 3.2h-1.794v-1.854h1.796v1.854h-.002zm0-3.2h-1.794V6.959h1.796v1.853h-.002zm3.23 3.2h-1.797v-1.854h1.796v1.854zm0-3.2h-1.797V6.959h1.796v1.853z",
  fill: "#000"
})));